import { IAttrValue } from "@multiweb/types/contracts";
import { ITextBuilder } from "../../../../Global/Base/Builders/ITextBuilder";
import { Column } from "../Columns/Column";
import { ICellContent } from "../Components/ICellContent";
import { ITemplate } from "./ITemplate";

export class FooterTemplate implements ITemplate {
    private _column: Column;

    public get parentColumn(): Column {
        return this._column;
    }

    public set parentColumn(v: Column) {
        this._column = v;
    }

    public init(): void {
        // Prazdna metoda
    }

    public render(): ICellContent {
        throw Error("Not implemented");
    }

    public updateData(_data: IAttrValue[], _item: HTMLElement): void {
        throw Error("Not implemented");
    }

    public updateDisplayedData(_data: ITextBuilder, _item: HTMLElement): void {
        throw Error("Not implemented");
    }

    public dispose(): void {
        // Prazdna metoda
    }
}
